import { useContext } from "react";

import { ClaimsContext } from "./ClaimsContext";

export const useClaimsContext = () => {
  const context = useContext(ClaimsContext);

  if (context === undefined) {
    throw new Error("useClaimsContext must be used within a ClaimsContext");
  }

  return context;
};
